<!-- <app-page-header Heading="Whatsapp Configuration" Description="">
    <div class="btn btn-sm btn-primary" (click)="openWhatsappConfigForm()">Add New WhatsApp Configuration</div>
</app-page-header>

<app-pagination [EnablePageSize]="true" [rowData]="whatsAppConfigList" (pageSizeChanged)="handlePageSizeChange($event)">
</app-pagination> -->

<div class="d-flex justify-content-between align-items-center w-100">

    <div class="d-flex align-items-center gap-3">
        <app-page-header Heading="WhatsApp Configuration" Description="">
        </app-page-header>

        <app-pagination 
            [EnablePageSize]="true" 
            [rowData]="whatsAppConfigList" 
            (pageSizeChanged)="handlePageSizeChange($event)">
        </app-pagination>
    </div>

    <div class="d-flex align-items-center">
        <button class="btn btn-sm btn-primary shadow-sm" (click)="openWhatsappConfigForm()" [disabled]="isLoading || isSubmitting">
            <i class="bi bi-whatsapp me-1"></i> Add New WhatsApp Configuration
        </button>
    </div>

</div>

<ng-container *ngIf="isLoading; else whatsAppConfigTableContent">
    <div class="card mb-1">
        <div class="card-header d-flex align-items-center">
            <ngx-skeleton-loader count="1" width="120px" height="20px"></ngx-skeleton-loader>
            <span class="ml-2">
                <ngx-skeleton-loader count="1" width="150px" height="16px"></ngx-skeleton-loader>
            </span>
        </div>
        <div class="card-body">
            <ngx-skeleton-loader count="3" width="100%" height="14px" style="margin-bottom: 8px;"></ngx-skeleton-loader>
        </div>
    </div>
</ng-container>

<ng-template #whatsAppConfigTableContent>
    <app-color-table [columns]="[
        {colName:'Name',colData:'iName'},
        {colName:'Description',colData:'iDesc'},
        {colName:'WaBa ID',colData:'wabaId'},
        {colName:'Whatsapp URL',colData:'waUrl'},
        {colName:'phoneNo Id',colData:'phoneNoId'},
        {colName:'Phone No',colData:'phoneNo'},
        {colName:'User Access Token', colData:'userAccessToken'}, 
        ]" [tableData]="this.whatsAppConfigList" [enableActionColumn]="true" [actionColumnLabel]="'Action'"
        [actionOptions]="[{actionName:'Edit',actionIcon:'fa fa-edit'},{ actionName: 'View', actionIcon: 'fa fa-eye' },{actionName:'Delete',actionIcon:'fa fa-trash'}]"
        (actionClick)="handleActionClick($event)" [DataLoading]="isLoading">
    </app-color-table>
</ng-template>


<app-pagination [EnableNavigation]="true" [rowData]="whatsAppConfigList"
    (pageSizeChanged)="handlePageSizeChange($event)">
</app-pagination>

<ng-template #whatsappConfigModalContent>

    <div class="modal-header">
        <h5 class="modal-title">New WhatsApp Configuration</h5>
        <button type="button" class="btn-close" (click)="addWhatsappConfigModal.close()"></button>
    </div>
    <div class="modal-body">
        <form [formGroup]="whatsappConfigForm">
            <div class="row">
                <div class="col-md-12">
                    <div class="form-group">
                        <label for="name">Name</label><span style="color: red;">*</span>
                        <input type="text" class="form-control form-control-sm "
                            [formControl]="whatsappConfigForm.controls.iName" placeholder="Name">
                        <app-form-errors [control]="whatsappConfigForm.controls.iName"></app-form-errors>
                    </div>
                </div>
            </div>
            <div class="row mt-2">
                <div class="col-md-12">
                    <div class="form-group">
                        <label for="description">Description</label>
                        <textarea type="text" class="form-control form-control-sm"
                            [formControl]="whatsappConfigForm.controls.iDesc" placeholder="Description"></textarea>
                    </div>
                </div>
            </div>
            <div class="row mt-2">
                <div class="col-md-12">
                    <div class="form-group">
                        <label for="aToken">WaBa ID</label><span style="color: red;">*</span>
                        <input class="form-control form-control-sm " [formControl]="whatsappConfigForm.controls.wabaId"
                            placeholder="WhatsappConfig ID">
                        <app-form-errors [control]="whatsappConfigForm.controls.wabaId"></app-form-errors>
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="form-group">
                        <label for="waURL">Whatsapp URL</label><span style="color: red;">*</span>
                        <input class="form-control form-control-sm " [formControl]="whatsappConfigForm.controls.waUrl"
                            placeholder="Whatsapp URL">
                        <app-form-errors [control]="whatsappConfigForm.controls.waUrl"></app-form-errors>
                    </div>
                </div>
            </div>
            <div class="row mt-2">
                <div class="col-md-6">
                    <div class="form-group">
                        <label for="description">Phone No Id</label>
                        <input class="form-control form-control-sm " type="number"
                            [formControl]="whatsappConfigForm.controls.phoneNoId" placeholder="Phone No Id">
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label for="description">Phone No</label>
                        <input class="form-control form-control-sm " [formControl]="whatsappConfigForm.controls.phoneNo"
                            placeholder="Phone No">
                    </div>
                </div>
            </div>
            <div class="row mt-2">
                <div class="col-md-12">
                    <div class="form-group">
                        <label for="aToken">Access Token</label><span style="color: red;">*</span>
                        <textarea class="form-control form-control-sm"
                            [formControl]="whatsappConfigForm.controls.userAccessToken"
                            placeholder="Access Token"></textarea>
                        <app-form-errors [control]="whatsappConfigForm.controls.userAccessToken"></app-form-errors>
                    </div>
                </div>
            </div>
            <div class="row mt-2">
            </div>
            <!--  
            <div class="row mt-2">
                <div class="col-md-6">
                    <div class="form-group">
                        <label for="mProduct">Meta Product</label>
                        <input class="form-control form-control-sm "
                            [formControl]="whatsappConfigForm.controls.mProduct" placeholder="Meta Product">
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label for="description">Integration Type</label>
                        <input class="form-control form-control-sm "
                            [formControl]="whatsappConfigForm.controls.iType" placeholder="Integration Type">
                    </div>
                </div>
            </div> -->

        </form>
    </div>
    <div class="modal-footer mt-3">
        <button type="button" class="btn btn-primary" (click)="submitWhatsappConfigForm()" [disabled]="isSubmitting">
            <ng-container *ngIf="!isSubmitting; else savingButton">
                Submit
            </ng-container>
            <ng-template #savingButton>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                Submitting...
            </ng-template>
        </button>

        <button type="button" class="btn btn-secondary" (click)="addWhatsappConfigModal.close()">Close</button>
    </div>
</ng-template>